import React from 'react';

import { useLanguage } from '../i18n/LanguageContext';


export default function Hero({ children, title, eyebrow }) {
  const { strings } = useLanguage();
  const defaultEyebrow = strings.hero.eyebrow || '';
  const defaultTitleRaw = strings.hero.title || '';

  const renderTitle = (raw) => {
    return raw.split('\n').map((line, i) => (
      <React.Fragment key={i}>{i ? <><br/>{line}</> : line}</React.Fragment>
    ));
  };

  return (
    <section className="hero">
      <div className="hero-inner">
        <p className="hero-eyebrow">{eyebrow || defaultEyebrow}</p>
        <h1 className="hero-title">{title ? renderTitle(title) : renderTitle(defaultTitleRaw)}</h1>
        <div className="hero-cta">{children}</div>
      </div>
    </section>
  );
}
